import React, { useContext, useState, useEffect } from "react";
import Utils from "Utils/utils";
import { observer } from "mobx-react";
import { ReactComponent as LinkedinIcon } from "Assets/svg/linkedin.svg";
import { outboxStoreData } from "./outboxStore";
import { OutboxContext } from "./main";

const TopFilterContents = observer(({ }) => {
  const [selectedSubstatus, setSelectedSubstatus] = useState(null);
  const {
    inputValues = {},
    handleStateChange = () => { },
    setAllEmailsSelectedCheckbox = () => { },
    setAllEmailsSelectedInView = () => { }
  } = useContext(OutboxContext);

  useEffect(() => {
    if (outboxStoreData?.activeFilter?.name === "replied") {
      if (!outboxStoreData?.repliedSubstatus && outboxStoreData?.setRepliedSubstatus) {
        outboxStoreData.setRepliedSubstatus("ALL");
      }
      if (selectedSubstatus === null) {
        const storeValue = outboxStoreData?.repliedSubstatus || "ALL";
        setSelectedSubstatus(storeValue);
        if (outboxStoreData?.setRepliedSubstatus && !outboxStoreData.repliedSubstatus) {
          outboxStoreData.setRepliedSubstatus(storeValue);
        }
      }
    }
  }, [outboxStoreData?.activeFilter?.name]);

  const { filterObject = {}, filterLoading = false, outboxData = {} } = inputValues || {};
  const { totalElements = 0 } = outboxData || {};
  const isRepliedActive = outboxStoreData?.activeFilter?.name === "replied";

  const {
    count = 0,
    activeCount = 0,
    openCount = 0,
    clickCount = 0,
    replyCount = 0,
    sentCount = 0,
    bounceCount = 0,
    nonOpenedCount = 0,
    failedCount = 0,
    autoReplyCount = 0,
    liCrAcceptedCount = 0,
    liCrSentCount = 0,
    profileViewsCount = 0,
    importantCount = 0
  } = filterObject || {};

  const filterData = [
    {
      label: "Replied",
      name: "replied",
      id: "REPLY_COUNT",
      count: (isRepliedActive ? totalElements : replyCount) || 0,
      substatusList: [
        { label: "Read", id: "READ" },
        { label: "Unread", id: "UNREAD" }
      ],
      isSubstatus: true
    },
    {
      label: "Scheduled",
      name: "scheduled",
      id: "ACTIVE",
      count: activeCount || 0
    },
    {
      label: "Sent",
      name: "delivered",
      id: "SENT",
      count: sentCount || 0
    },
    {
      label: "All",
      name: "all",
      id: "ALL",
      count: count || 0
    },
    {
      label: "Opened",
      name: "opened",
      id: "OPEN_COUNT",
      count: openCount || 0
    },
    {
      label: "Clicked",
      name: "clicked",
      id: "CLICK_COUNT",
      count: clickCount || 0
    },
    {
      label: "Bounced",
      name: "bounced",
      id: "BOUNCE_COUNT",
      count: bounceCount || 0
    },
    {
      label: "Not Opened",
      name: "not_opened",
      id: "NOT_OPEN_COUNT",
      count: nonOpenedCount || 0
    },
    {
      label: "Failed",
      name: "failed",
      id: "ERROR",
      count: failedCount || 0
    },
    {
      label: "Auto Replies",
      name: "auto_reply",
      id: "AUTO_REPLY_COUNT",
      count: autoReplyCount || 0
    },
    {
      label: "Requests sent",
      name: "requests_sent",
      id: "LI_CR_SENT_COUNT",
      count: liCrSentCount || 0,
      isFromLi: true
    },
    {
      label: "Accepted",
      name: "accepted",
      id: "LI_CR_ACCEPTED_COUNT",
      count: liCrAcceptedCount || 0,
      isFromLi: true
    },
    {
      label: "Profiles Viewed",
      name: "profiles_viewed",
      id: "LI_PROFILE_VIEWS_COUNT",
      count: profileViewsCount || 0,
      isFromLi: true
    },
    {
      label: "Important",
      name: "important",
      id: "IMPORTANT",
      count: importantCount || 0
    }
  ];

  const filterAction = (item = {}, event, skipRadioCheck = false, substatusIdOverride = null) => {
    if (event && !skipRadioCheck) {
      const target = event.target;
      const isRadioClick =
        target.type === 'radio' ||
        target.closest('.substatusRadioContainer') ||
        target.closest('.substatusRadioLabel') ||
        target.classList.contains('substatusRadioText') ||
        target.classList.contains('substatusRadioInput');

      if (isRadioClick) {
        return;
      }
    }
    const { name = "", id = "", isSubstatus = false } = item || {};

    if (name === "replied" && isSubstatus && !outboxStoreData?.repliedSubstatus && outboxStoreData?.setRepliedSubstatus) {
      outboxStoreData.setRepliedSubstatus("ALL");
    }
    outboxStoreData.setCurrentPage(1);
    outboxStoreData.setActiveFilter({ name, id });
    handleStateChange("all", {
      filterLoading: true,
      dataLoading: true
    });
    setAllEmailsSelectedCheckbox(false);
    setAllEmailsSelectedInView(false);
    outboxStoreData.setActiveOutboxId("");
    if (isSubstatus) {
      let substatusToUse;
      if (substatusIdOverride !== null && substatusIdOverride !== undefined) {
        substatusToUse = substatusIdOverride;
        setSelectedSubstatus(substatusToUse);
        try {
          if (outboxStoreData?.setRepliedSubstatus) {
            outboxStoreData.setRepliedSubstatus(substatusToUse);
          }
        } catch (error) {
          console.error("Error setting replied substatus:", error);
        }
      } else if (selectedSubstatus !== null && selectedSubstatus !== undefined) {
        substatusToUse = selectedSubstatus;
        try {
          if (outboxStoreData?.setRepliedSubstatus) {
            outboxStoreData.setRepliedSubstatus(substatusToUse);
          }
        } catch (error) {
          console.error("Error setting replied substatus:", error);
        }
      } else {
        substatusToUse = outboxStoreData.repliedSubstatus || "ALL";
        setSelectedSubstatus(substatusToUse);
        try {
          if (outboxStoreData?.setRepliedSubstatus) {
            outboxStoreData.setRepliedSubstatus(substatusToUse);
          }
        } catch (error) {
          console.error("Error setting replied substatus:", error);
        }
      }
    }
  };

  return (
    <div className="filterContentsWrapper" id="outboxFilter">
      {!filterLoading && filterData?.length > 0
        ? filterData?.map((item, key) => {
          const {
            name = "",
            count = 0,
            label = "",
            isFromLi = false,
            isSubstatus = false,
            substatusList = []
          } = item || {};
          const isActive = outboxStoreData?.activeFilter?.name === name;
          return (
            <div
              className={`filterContainer ${isActive ? "active" : ""}`}
              key={key}
              onClick={(e) => {
                if (isActive && isSubstatus && selectedSubstatus) {
                  filterAction(item, e, false, selectedSubstatus);
                } else {
                  filterAction(item, e);
                }
              }}
            >
              <div className="filterOption">
                <div className="filterValueCont">
                  <div className="flexValue">
                    <span className="filterValue">
                      {count ? Utils.formatNumberToString(count) : 0}
                    </span>
                    {isFromLi && (
                      <span className="liIcon">
                        <LinkedinIcon />
                      </span>
                    )}
                  </div>
                  <span className="filterLabel">{label}</span>
                </div>
              </div>
            </div>
          );
        })
        : Array.from({ length: 14 }, (_, index) => (
          <li
            className="linear-background"
            key={`seqContactsNavLoader${index}`}
          />
        ))}
    </div>
  );
});

export { TopFilterContents };
export default TopFilterContents;
